import {useEffect, useState} from "react";
import {baseApi} from "../../api/axios";
import {useAuthStore} from "../../store/user-store";

export default function OrderItem({order}) {

    const [item, setItem] = useState(order)
    const [loading, setLoading] = useState(false)
    const authStore = useAuthStore()

    useEffect(() => {
        let timer = setInterval(async () => {
            if (!loading) {
                getStatus();
            }
        }, 15000);

        return () => {
            clearInterval(timer);
        };
    }, [loading]);

    const getStatus = async () => {
        setLoading(true);
        try {
            if (item.is_pending === true) {
                const response = await baseApi.get(`/orders/${order.id}`);
                if (response.data?.order) {
                    if (response.data?.order.is_pending === false) {

                        setItem(response.data?.order);
                        if (response.data?.user) {
                            authStore.setUser(response.data?.user)
                            localStorage.setItem('user', JSON.stringify(response.data?.user))
                        }
                    }
                }
            }
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    };

    return (
        <div className={`card  my-2 ${order.status_en=='pending'?'bg-info':order.status_en=='cancel'?'bg-danger' : 'bg-success'} text-white`}>
            <div className="card-title"> {order.product} #<span className={'text-warning'}>{order.id}</span></div>
            <div className="card-body ">
                <div className={'d-flex justify-content-between'}>
                <span>السعر : {order.price.toFixed(authStore.currency==='syr'?0:2)} {authStore.currency==='syr'?'ل.س':'$'}</span>
                <span >بيانات الحساب :
                    {order.send_data?.player_id ?
                        <span className={'text-warning'}> ID : {order.send_data?.player_id}</span> : null}
                    {order.send_data?.email ?
                        <span className={'text-warning'}> Email : {order.send_data?.email}</span> : null}
                    {order.send_data?.password ?
                        <span className={'text-warning'}> Password : {order.send_data?.password}</span> : null}
                    {order.send_data?.qty ? <span className={'text-warning'}> الكمية : {order.send_data?.qty}</span> : null}
                </span>

            </div>
                <span>الرد: {item?.receive_data?.msg}</span>
            </div>
            <div className="card-footer">
                <div className={'d-flex justify-content-between'}>
                <span>الحالة : {item?.status}</span>
                <span> التاريخ : {order.created_at}</span>
                </div>
            </div>
        </div>

    )
}